import createReducer from 'storeContext/reducers/createReducer'
import type { PayloadActionType } from 'storeContext/reducers/createReducer'
import type {
  BoMComponentType,
  BoMComponentsResponseType,
  BoMItemResponseType,
  BoMItemType,
  BoMQueryType,
} from 'utils/apiList/bom'
import type { BoMProductOptionType } from 'utils/api'
import {
  SET_IS_LOADING,
  SET_QUERY,
  SET_RESET,
  SET_BOM_ITEM,
  SET_FORM,
  SET_COMPONENTS,
  SET_SELECTED_COMPONENTS,
  SET_REMOVE_COMPONENT,
  SET_PRODUCTS,
  SET_QTY,
  SET_IS_SHOW_PRODUCT_HUB,
  SET_HUBS_BY_PRODUCT,
  SET_FINISH_ADD_HUB_TO_PRODUCT,
  SET_PRODUCT_DETAIL,
} from 'storeContext/actionsType/bomAddEdit'

export type BoMAddEditFormType = {
  product: BoMProductOptionType | null
  total: number
  uom: string | number
  criteria: string
  note: string
  active: boolean
}

export type BoMAddEditHubType = {
  id: number
  name: string
}

export type BoMAddEditStateType = {
  isLoading: boolean
  query: Partial<BoMQueryType>
  pagination: {
    pageSize?: number
    currentPage?: number
    totalPage?: number
  }
  data: BoMItemType | null
  form: BoMAddEditFormType
  components: BoMComponentType[]
  mergedComponents: Record<string, BoMComponentType>
  products: BoMProductOptionType[]
  isShowModalAddProductHub: boolean
  hubs: BoMAddEditHubType[]
}

export type BoMAddEditQueryPayloadType = {
  query: Partial<BoMQueryType>
  params: { id?: string }
}

export type BoMAddEditFormPayloadType = {
  [KeyType in keyof BoMAddEditFormType]: {
    key: KeyType
    value: BoMAddEditFormType[KeyType]
  }
}[keyof BoMAddEditFormType]

export type BoMAddEditQtyPayloadType = {
  id: string | number
  value: string | number
}

export const initialStateBoMAddEdit: BoMAddEditStateType = {
  isLoading: false,
  query: {},
  pagination: {},
  data: null,
  form: {
    product: null,
    total: 1,
    uom: '',
    criteria: '',
    note: '',
    active: false,
  },
  components: [],
  mergedComponents: {},
  products: [],
  isShowModalAddProductHub: false,
  hubs: [],
}

const bomReducer = createReducer<BoMAddEditStateType>({
  [SET_IS_LOADING]: (state, action: PayloadActionType<boolean>) => {
    state.isLoading = action.payload
  },
  [SET_QUERY]: (state, action: PayloadActionType<BoMAddEditQueryPayloadType>) => {
    state.query = {
      ...state.query,
      ...action.payload.query,
    }
  },
  [SET_BOM_ITEM]: (state, action: PayloadActionType<BoMItemResponseType>) => {
    const { data } = action.payload
    const { productCriteria, note, active } = data
    state.data = data
    state.form.criteria = productCriteria
    state.form.note = note
    state.form.active = active
  },
  [SET_FORM]: (state, action: PayloadActionType<BoMAddEditFormPayloadType>) => {
    const { key, value } = action.payload
    const form = state.form as Record<
      keyof BoMAddEditFormType,
      BoMAddEditFormType[keyof BoMAddEditFormType]
    >

    form[key] = value
  },
  [SET_COMPONENTS]: (state, action: PayloadActionType<BoMComponentsResponseType>) => {
    const { data, pagination } = action.payload
    const { pageSize, pageIndex, totalElement } = pagination

    data.forEach((item) => {
      state.mergedComponents[item.productId] = item
    })

    state.components = data
    state.pagination = {
      pageSize,
      currentPage: pageIndex,
      totalPage: Math.ceil(totalElement / pageSize),
    }
    state.isLoading = false
  },
  [SET_SELECTED_COMPONENTS]: (
    state,
    action: PayloadActionType<Record<string, BoMComponentType> | []>,
  ) => {
    const selectedComponents = action.payload as Record<string, BoMComponentType>

    Object.keys(selectedComponents).forEach((key) => {
      state.mergedComponents[key] = selectedComponents[key]
    })
  },
  [SET_REMOVE_COMPONENT]: (state, action: PayloadActionType<string | number>) => {
    const id = action.payload
    delete state.mergedComponents[id]
  },
  [SET_PRODUCTS]: (state, action: PayloadActionType<BoMProductOptionType[]>) => {
    state.products = action.payload

    state.form.criteria = 'BoM'
  },
  [SET_PRODUCT_DETAIL]: (state, action: PayloadActionType<BoMProductOptionType>) => {
    const product = action.payload
    state.form.product = product
    state.form.uom = product.baseUom
    state.form.criteria = product.bomCategory
  },
  [SET_QTY]: (state, action: PayloadActionType<BoMAddEditQtyPayloadType>) => {
    const { id, value } = action.payload

    state.mergedComponents[id].qty = value
  },
  [SET_RESET]: () => initialStateBoMAddEdit,
  [SET_IS_SHOW_PRODUCT_HUB]: (state, action: PayloadActionType<boolean>) => {
    state.isShowModalAddProductHub = action.payload
  },
  [SET_HUBS_BY_PRODUCT]: (state, action: PayloadActionType<BoMAddEditHubType[]>) => {
    state.hubs = action.payload
  },
  [SET_FINISH_ADD_HUB_TO_PRODUCT]: (state) => {
    state.isShowModalAddProductHub = false
    state.hubs = []
  },
})

export default bomReducer
